import styled from "styled-components";
import { Link } from "../link";

const FancyUnderline = styled(Link)`
  flex: 1;
  display: inline;
  text-decoration: none;
  background-image: linear-gradient(
    to right,
    ${(props) => props.theme.colors.tangerine} 0,
    ${(props) => props.theme.colors.tangerine} 100%
  );
  background-position: 0px 23px;
  background-size: 0 100%;
  background-repeat: no-repeat;
  transition: background 0.5s;
  cursor: pointer;
  color: ${(props) => props.theme.colors.cardinal};
  font-weight: 400;
  &:hover {
    background-image: linear-gradient(
      to right,
      ${(props) => props.theme.colors.delta} 0,
      ${(props) => props.theme.colors.delta} 100%
    );
    background-size: 100% 100%;
  }
`;

export { FancyUnderline };
